module.exports = __webpack_public_path__ + "static/media/image1.8b341dcf.png";